import React, { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  CssBaseline,
  TextField,
  FormControlLabel,
  Checkbox,
  Link,
  Paper,
  Grid,
  Box,
  Typography,
  Button,
  CircularProgress,
  InputAdornment,
  IconButton,
} from "@mui/material";

import { useHistory } from "react-router-dom";
import { login } from "../../actions/auth";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import styled from "styled-components";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useForm } from "react-hook-form";
import { barerockUrl } from "../../utils/constants";
import { useTheme } from "@emotion/react";
export default function Login() {
  const history = useHistory();
  const dispatch = useDispatch();
  const { loginLoading } = useSelector((state) => state.auth);
  const theme = useTheme();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [showPassword, setShowPassword] = useState(false);
  const passwordRef = useRef(null);

  const handleDelayedFocus = () => {
    setTimeout(() => {
      if (passwordRef.current) {
        passwordRef.current.focus();
      }
    }, 30);
  };

  const handleShowPassword = () => {
    setShowPassword((prev) => !prev);
    handleDelayedFocus();
  };

  const handleLogin = (data) => {
    const { email, password } = data;
    let formData = new FormData();
    const user = {
      email,
      password,
      login_from: "marketplace",
    };

    for (let key in user) {
      formData.append(key, user[key]);
    }
    formData.append("request_formdata_json", true);
    dispatch(login(formData, history));
  };

  const background = theme?.palette?.primary?.main;
  const color = theme?.palette?.background?.default;

  const buttonStyle = {
    color,
    background,
    fontSize: "1.1rem",
    opacity: 1,
    "&:hover": {
      background,
      color: theme?.palette?.background?.default,
      opacity: 0.6,
    },
    "&:disabled": {
      background,
      color: theme?.palette?.background?.default,

      opacity: 0.6,
    },
    borderRadius: 30,
    padding: "10px 20px",
    fontWeight: "bold",
    // width: "23rem",
  };

  const emailError = errors?.email?.message;
  const passwordError = errors?.password?.message;

  return (
    <Grid container component="main" sx={{ height: "100vh" }}>
      <CssBaseline />
      <Grid
        item
        xs={false}
        sm={false}
        md={5}
        lg={7}
        sx={{
          backgroundImage: "url(/assets/images/login-thumbnail.jpg)",
          // backgroundColor: "#35314E",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <Grid
        item
        xs={12}
        sm={12}
        md={7}
        lg={5}
        component={Paper}
        elevation={6}
        square
      >
        <Box
          sx={{
            p: 4,
            mx: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            maxWidth: "1500px",
            margin: "auto",
            // maxWidth: "23rem",
            // height: "100vh",
          }}
        >
          <Box maxWidth="23rem">
            <Box
              component="img"
              src={`/assets/images/emblem.png`}
              alt=""
              sx={{ height: "100px", width: "100%", objectFit: "contain" }}
              elevation={0}
            />

            <Typography component="h1" variant="h5">
              Log in to your portal
            </Typography>
          </Box>
          <Wrapper>
            <form
              noValidate
              onSubmit={handleSubmit(handleLogin)}
              style={{ mt: 1, p: 6 }}
            >
              <TextField
                {...register("email", {
                  required: "Email is required",
                  pattern: {
                    value: /\S+@\S+\.\S+/,
                    message: "Entered value does not match email format",
                  },
                })}
                margin="normal"
                fullWidth
                id="email"
                label="Email Address"
                name="email"
                InputProps={{
                  sx: {
                    // width: "23rem",
                  },
                }}
              />
              {emailError && (
                <Typography sx={{ fontSize: "13px", color: "red" }}>
                  {emailError}
                </Typography>
              )}
              <TextField
                inputRef={passwordRef}
                {...register("password", { required: "Password is required" })}
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                type={showPassword ? "text" : "password"}
                id="password"
                sx={{
                  borderRadius: "50px",
                  WebkitBoxShadow: "0 0 0 1000px white inset",
                }}
                InputProps={{
                  sx: {
                    WebkitBoxShadow: "0 0 0 1000px white inset",
                  },
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleShowPassword}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              {passwordError && (
                <Typography sx={{ fontSize: "13px", color: "red" }}>
                  {passwordError}
                </Typography>
              )}

              <FormControlLabel
                control={<Checkbox value="remember" color="primary" />}
                label="Remember me"
              />
              <Box mt={2} mb={2}>
                <Button
                  sx={buttonStyle}
                  disabled={loginLoading}
                  type="submit"
                  fullWidth
                  endIcon={
                    loginLoading ? (
                      <CircularProgress sx={{ color: "#FFF" }} size="20px" />
                    ) : (
                      <ChevronRightIcon />
                    )
                  }
                  style={{ textAlign: "start" }}
                >
                  Sign In
                </Button>
              </Box>

              <Grid container>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  sx={{ textAlign: { xs: "center", sm: "left" } }}
                >
                  <Link
                    underline="none"
                    href="/forgot-password"
                    variant="body2"
                    style={{ fontSize: 13 }}
                  >
                    Forgot password?
                  </Link>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  sx={{ textAlign: { xs: "center", sm: "right" } }}
                >
                  <Link
                    underline="none"
                    target="_blank"
                    href={barerockUrl}
                    variant="body2"
                    style={{ fontSize: 13 }}
                  >
                    {"Don't have an account?"}
                  </Link>
                </Grid>
              </Grid>
            </form>
          </Wrapper>
        </Box>
      </Grid>
    </Grid>
  );
}

export const Wrapper = styled.div`
  width: 100%;
  .text-danger {
    color: red;
    font-size: 0.9rem;
  }
`;
